<template>
    <tr class="c-tr">
        <td @click="openDonationDetails(data)">{{ formatDate(data.date) }}</td>
        <td @click="openDonationDetails(data)" align="right">{{ formatCurrency(data.amount) }}</td>
        <td @click="openDonationDetails(data)">{{ data.campaign }}</td>
        <td @click="openDonationDetails(data)">{{ data.designation }}</td>
        <td>
            <div class="d-flex justify-content-start">
                <img v-if="data.is_fee_covered" src="@/assets/images/supporters/fee-blue.svg" />
                <img v-else src="@/assets/images/supporters/fee.svg" />

                <img v-if="data.is_monthly" class="ml-3" src="@/assets/images/supporters/recurring-blue.svg" />
                <img v-else class="ml-3" src="@/assets/images/supporters/recurring.svg" />

                <img v-if="data.has_comment" class="ml-3" src="@/assets/images/supporters/comment-blue.svg" />
                <img v-else class="ml-3" src="@/assets/images/supporters/comment.svg" />

                <img
                    v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.SUPPORTERS_SEND_RECEIPT)"
                    class="ml-3" src="@/assets/images/supporters/receipt-blue.svg" style="cursor: pointer" @click="sendReceipt" />

            </div>
        </td>
    </tr>
</template>

<script>
import DibbleJS from "@/dibble";
import DibbleApi from "@/api";
import Authorizations from "@/utils/authorizations";

export default {
    name: 'TableItem',
    computed: {
        DibbleJS() {
            return DibbleJS
        }
    },
    props: {
        data: Object,
    },
    data() {
        return {
            MODULE_NAMES: Authorizations.MODULE_NAMES,
        }
    },
    methods: {
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        formatDate(date) {
            return this.$moment(date).format('MM/DD/YYYY HH:mm');
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
        },
        sendReceipt() {
            DibbleJS.confirmBox('Resend the receipt to the supporter?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    '#request': DibbleApi.api.donationResendReceipt,
                    donation_id: this.data.donation_id
                }, (response) => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage(response.message)
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                }, this._onLoadBoatTypeFailed)
            })
        },
        openDonationDetails(data) {
            this.$router.push({
                'name': 'DonationView',
                params: {
                    id: data.donation_id,
                },
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.c-tr {
    td {
        color: #7c7c7a;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        cursor: pointer;

        &:first-child {
            min-width: 200px;
        }
    }
}
</style>
